<script lang="ts">
  import type { MessageElement } from '$lib/protocol/types';

  import type { ElementContext } from './context';
  import AnswerView from './AnswerView.svelte';
  import CalendarEventView from './CalendarEventView.svelte';
  import CartView from './CartView.svelte';
  import HtmlView from './HtmlView.svelte';
  import ImageView from './ImageView.svelte';
  import LocationView from './LocationView.svelte';
  import NotificationView from './NotificationView.svelte';
  import OrderView from './OrderView.svelte';
  import PaymentRequestView from './PaymentRequestView.svelte';
  import QuestionView from './QuestionView.svelte';
  import RequestView from './RequestView.svelte';
  import TextView from './TextView.svelte';
  import UnknownView from './UnknownView.svelte';
  import VideoView from './VideoView.svelte';
  import VoiceView from './VoiceView.svelte';

  let { element, ctx }: { element: MessageElement; ctx: ElementContext } = $props();
</script>

{#if element.type === 'text'}
  <TextView {element} />
{:else if element.type === 'voice'}
  <VoiceView {element} {ctx} />
{:else if element.type === 'image'}
  <ImageView {element} {ctx} />
{:else if element.type === 'question'}
  <QuestionView {element} {ctx} />
{:else if element.type === 'answer'}
  <AnswerView {element} />
{:else if element.type === 'request'}
  <RequestView {element} />
{:else if element.type === 'cart'}
  <CartView {element} {ctx} />
{:else if element.type === 'order'}
  <OrderView {element} />
{:else if element.type === 'notification'}
  <NotificationView {element} />
{:else if element.type === 'payment_request'}
  <PaymentRequestView {element} />
{:else if element.type === 'location'}
  <LocationView {element} />
{:else if element.type === 'calendar_event'}
  <CalendarEventView {element} {ctx} />
{:else if element.type === 'video'}
  <VideoView {element} {ctx} />
{:else if element.type === 'html'}
  <HtmlView {element} {ctx} />
{:else}
  <UnknownView {element} />
{/if}
